// The i18next singleton, as planFeatures/locale: importing '../i18n' here loaded every
// translation into each screen that imports a role label (and its tests).
import i18n from 'i18next';

/** Built-in roles carry name_ar (and a custom role may have one too); show it in Arabic, else the English name. */
export const roleLabel = (role) => (i18n.language === 'ar' && role?.name_ar) || role?.name || '';
